import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=1bf601e0&scoped=true&"
import script from "./Process.vue?vue&type=script&lang=js&"
export * from "./Process.vue?vue&type=script&lang=js&"
import style0 from "./Process.vue?vue&type=style&index=0&id=1bf601e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf601e0",
  null
  
)

export default component.exports